// extracted by mini-css-extract-plugin
export var overlay = "overlay-module--overlay--69201";
export var overlay__menu = "overlay-module--overlay__menu--7ab03";
export var overlay__open = "overlay-module--overlay__open--8cb71";
export var spin = "overlay-module--spin--49eec";